<div class="p-2">
  <ng-template vdrDialogTitle>
    <div class="title-row px-2 pt-2">
      <span>Chọn {{ type === 'IMAGE' ? 'ảnh' : 'file' }}</span>
      <div class="flex-spacer"></div>
      <vdr-asset-file-input
        class="ml3"
        (selectFiles)="createAssets($event)"
        [uploading]="uploading"
        dropZoneTarget=".modal-content"
        [accept]="accept"
      ></vdr-asset-file-input>
    </div>
  </ng-template>

  <div class="relative">
    <vdr-asset-gallery
      [assets]="(assets$ | async)! | paginate: paginationConfig"
      [multiSelect]="multiSelect"
      [canDelete]="true"
      (selectionChange)="selection = $event"
      (deleteAssets)="deleteSelectedAssets($event)"
      (editAssetClick)="cancel()"
      #assetGalleryComponent
    ></vdr-asset-gallery>
    <div
      *ngIf="loading$ | async"
      class="absolute inset-0 bg-white bg-opacity-75 flex items-center justify-center"
    >
      <div class="flex flex-col items-center gap-2">
        <clr-spinner />
        <span class="text-sm text-gray-600">Đang tải...</span>
      </div>
    </div>
  </div>

  <div class="paging-controls">
    <vdr-items-per-page-controls
      [itemsPerPage]="paginationConfig.itemsPerPage"
      (itemsPerPageChange)="itemsPerPageChange($event)"
    ></vdr-items-per-page-controls>

    <vdr-pagination-controls
      [currentPage]="paginationConfig.currentPage"
      [itemsPerPage]="paginationConfig.itemsPerPage"
      [totalItems]="paginationConfig.totalItems"
      (pageChange)="pageChange($event)"
    ></vdr-pagination-controls>
  </div>

  <ng-template vdrDialogButtons>
    <div class="px-2 pb-2 flex gap-2">
      <button type="button" class="btn" (click)="cancel()">Hủy</button>
      <button
        type="submit"
        (click)="select()"
        class="btn btn-primary"
        [disabled]="selection.length === 0"
      >
        Lưu {{ selection.length }} {{ type === 'IMAGE' ? 'hình' : 'file' }}
      </button>
    </div>
  </ng-template>
</div>
